import { userStore, types } from "@/BaseComponent";
import { apiService, header } from "@/services/interceptor";
import { AxiosResponse } from "axios";
// import { AxiosResponse } from "axios";

export default {
    async list(param: types.ReqUserForList): Promise<types.ResPaging> {
        const res = {} as types.ResPaging;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/member/list", param, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },

    async detail(idx: number): Promise<types.ResMember> {
        const res = {} as types.ResMember;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/member/detail/" + idx, null, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },

    async modify(idx: number, param: types.ReqUserForModifyForAdmin): Promise<types.BaseResponse> {
        const res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/member/modify/" + idx, param, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },

    async remove(param: types.ReqIdxList): Promise<types.BaseResponse> {
        const res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/member/remove", param, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },

    async areaForPerformance(param: types.ReqMemberPerformance): Promise<types.ResPaging> {
        const res = {} as types.ResPaging;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/member/area/performance", param, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },

    async adForPerformance(param: types.ReqMemberPerformance): Promise<types.ResPaging> {
        const res = {} as types.ResPaging;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/member/ad/performance", param, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },

    async activityForPerformance(param: types.ReqMemberPerformance): Promise<types.ResPaging> {
        const res = {} as types.ResPaging;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/member/activity/performance", param, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },

    async eventForPerformance(param: types.ReqMemberPerformance): Promise<types.ResPaging> {
        const res = {} as types.ResPaging;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/member/campaignEvent/performance", param, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },

    async removeForSign(param: types.ReqIdxList): Promise<types.BaseResponse> {
        const res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/member/remove/sign", param, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },

    async status(): Promise<types.ResMemberStatus> {
        const res = {} as types.ResMemberStatus;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/member/status", null, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },

    async memberCnt(): Promise<types.ResMemberCnt> {
        const res = {} as types.ResMemberCnt;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/member/cnt", null, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },

    async exportExcel(param: types.ReqUserForExcel): Promise<any> {
        let res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response: AxiosResponse<Blob> = await apiService().post("/member/export/excel", param, {
                withCredentials: false,
                responseType: "blob",
            });

            return response;
        } catch (error: any) {
            console.error(error);
            res = error.response.data;
        }
        return res;
    },
};
